import type { Course } from "@/types/course";

export type SortKey = "default" | "tuition" | "satisfaction" | "employment3m";
export type SortDir = "asc" | "desc";

function numericValue(course: Course, key: SortKey): number | null {
  if (key === "tuition") return course.tuition;
  if (key === "satisfaction") return course.satisfaction;
  if (key === "employment3m") {
    if (course.employment3m === "-") return null;
    return parseFloat(course.employment3m);
  }
  return null;
}

export function sortCourses(
  list: Course[],
  key: SortKey,
  dir: SortDir,
): Course[] {
  if (key === "default") return list;
  return [...list].sort((a, b) => {
    const av = numericValue(a, key);
    const bv = numericValue(b, key);
    // '-' (데이터 없음)는 정렬 방향과 무관하게 항상 맨 아래
    if (av === null && bv === null) return 0;
    if (av === null) return 1;
    if (bv === null) return -1;
    return dir === "asc" ? av - bv : bv - av;
  });
}